import { createVNode, defineComponent, h, reactive, render } from 'vue'
import { Spin } from 'ant-design-vue'

export const PageLoading = defineComponent({
  name: 'PageLoading',
  props: {
    tip: {
      type: String,
      default: 'Loading..',
    },
    size: {
      type: String,
      default: 'large',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const style = {
      textAlign: 'center',
      background: 'rgba(0,0,0,0.6)',
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1100,
    }
    const spinStyle = {
      position: 'absolute',
      left: '50%',
      top: '40%',
      transform: 'translate(-50%, -50%)',
    }
    return () =>
      props.visible
        ? h('div', { style }, [
            h(Spin, {
              size: props.size,
              style: spinStyle,
              tip: props.tip,
            }),
          ])
        : null
  },
})

const version = '0.0.2'

const loading = {}

loading.newInstance = (options = {}) => {
  let loadingElement = document.querySelector('body>div[type=loading]')
  if (!loadingElement) {
    loadingElement = document.createElement('div')
    loadingElement.setAttribute('type', 'loading')
    loadingElement.setAttribute('class', 'ant-loading-wrapper')
    document.body.appendChild(loadingElement)
  }

  const state = reactive({ visible: false, size: 'large', tip: 'Loading...', ...options })
  const vnode = createVNode(PageLoading, state)
  render(vnode, loadingElement)

  function update(config) {
    Object.assign(state, config)
  }

  return {
    update,
  }
}

const api = {
  show(options) {
    this.instance.update({ ...options, visible: true })
  },
  hide() {
    this.instance.update({ visible: false })
  },
}

const install = function (app, options) {
  if (app.config.globalProperties.$loading) {
    return
  }
  api.instance = loading.newInstance(options)
  app.config.globalProperties.$loading = api
}

export default {
  version,
  install,
}
